var render = function render(){var _vm=this,_c=_vm._self._c;return _c('workOrderProgress',{attrs:{"title":"生产主页","show-quantity-column":false,"show-material-column":false,"work-order-data":_vm.workOrderData,"total-counts":_vm.totalCounts,"loading":_vm.loading},on:{"get-data":_vm.handleGetData,"production-click":_vm.handleProductionClick,"design-click":_vm.handleDesignClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }